import styled, { keyframes, css } from 'styled-components';
import { createElement, Component, createContext } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
}

var defaultBaseColor = '#eeeeee';
var defaultHighlightColor = '#f5f5f5';
var defaultDuration = 1.5;
var flash = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"], ["\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"])));

var getStyles = function getStyles(props) {
  return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  background-image: linear-gradient(\n    90deg,\n    ", ",\n    ", ",\n    ", "\n  );\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  display: inline-block;\n  animation: ", " ", "s ease-in-out infinite;\n  color: transparent !important;\n  > * {\n    color: transparent !important;\n  }\n  ", "\n"], ["\n  background-color: ", ";\n  background-image: linear-gradient(\n    90deg,\n    ", ",\n    ", ",\n    ", "\n  );\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  display: inline-block;\n  animation: ", " ", "s ease-in-out infinite;\n  color: transparent !important;\n  > * {\n    color: transparent !important;\n  }\n  ", "\n"])), props.theme.baseColor || props.baseColor, props.theme.baseColor || props.baseColor, props.theme.hightlightColor || props.highlightColor, props.theme.baseColor || props.baseColor, flash, props.duration, props.customStyle || '');
};

var screens = {
  sm: '@media (min-width: 576px)',
  md: '@media (min-width: 768px)',
  lg: '@media (min-width: 992px)',
  xl: '@media (min-width: 1200px)'
};

var bindProperty = function bindProperty(name, value) {
  if (Array.isArray(value)) {
    var response_1 = [];
    var count_1 = 0;
    response_1[count_1++] = name + ": " + value[0] + ";";
    Object.keys(screens).forEach(function (key, index) {
      if (typeof value[index + 1] === 'string') {
        response_1[count_1++] = screens[key] + "{" + name + ": " + value[index + 1] + ";}";
      }
    });
    return response_1.join('');
  }

  return name + ": " + value + ";";
};

var templateObject_1, templateObject_2;

var _a;

var SkeletonThemeConsumer = (_a = createContext({
  baseColor: '',
  hightlightColor: ''
}), _a.Consumer),
    SkeletonThemeProvider = _a.Provider;
var Container = styled.div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  line-height: 1;\n"], ["\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  line-height: 1;\n"])), function (props) {
  return getStyles(props);
}, function (props) {
  return bindProperty('width', props.cssProps.width);
}, function (props) {
  return bindProperty('height', props.cssProps.height);
}, function (props) {
  return bindProperty('border-radius', props.cssProps.radius);
});

var Skeleton =
/** @class */
function (_super) {
  __extends(Skeleton, _super);

  function Skeleton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Skeleton.prototype.shouldComponentUpdate = function () {
    return false;
  };

  Skeleton.prototype.render = function () {
    var _a = this.props,
        baseColor = _a.baseColor,
        highlightColor = _a.highlightColor,
        duration = _a.duration,
        customStyle = _a.customStyle,
        rest = __rest(_a, ["baseColor", "highlightColor", "duration", "customStyle"]);

    var splitProps = {
      baseColor: baseColor,
      highlightColor: highlightColor,
      duration: duration,
      customStyle: customStyle
    };
    return createElement(SkeletonThemeConsumer, null, function (theme) {
      return createElement(Container, _assign({
        cssProps: rest
      }, splitProps, {
        theme: theme
      }));
    });
  };

  Skeleton.defaultProps = {
    width: '100%',
    radius: '0px',
    height: '20px',
    duration: 1.5,
    baseColor: defaultBaseColor,
    highlightColor: defaultHighlightColor
  };
  return Skeleton;
}(Component);

var templateObject_1$1;
var TextWrapper = styled.span(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
  return getStyles(props);
});

var SkeletonString =
/** @class */
function (_super) {
  __extends(SkeletonString, _super);

  function SkeletonString() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SkeletonString.prototype.shouldComponentUpdate = function () {
    return false;
  };

  SkeletonString.prototype.render = function () {
    var _this = this;

    return createElement(SkeletonThemeConsumer, null, function (theme) {
      return createElement(TextWrapper, _assign({}, _this.props, {
        theme: theme
      }), _this.props.children);
    });
  };

  SkeletonString.defaultProps = {
    baseColor: defaultBaseColor,
    highlightColor: defaultHighlightColor,
    duration: defaultDuration
  };
  return SkeletonString;
}(Component);

var templateObject_1$2;
var Span = styled.span(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: transparent !important;\n"], ["\n  ", "\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  color: transparent !important;\n"])), function (props) {
  return getStyles(props);
}, function (props) {
  return bindProperty('padding', props.cssProps.padding);
}, function (props) {
  return bindProperty('height', props.cssProps.height);
}, function (props) {
  return bindProperty('margin', props.cssProps.margin);
}, function (props) {
  return bindProperty('border-radius', props.cssProps.radius);
});
var Container$1 = styled('div')({});

var SkeletonWords =
/** @class */
function (_super) {
  __extends(SkeletonWords, _super);

  function SkeletonWords() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.data = Array.isArray(_this.props.pattern) ? _this.props.pattern.map(function (num) {
      return 'a'.repeat(num);
    }) : Array.from({
      length: _this.props.num
    }, function () {
      return 'a'.repeat(Math.random() * 13 + 1);
    });
    return _this;
  }

  SkeletonWords.prototype.shouldComponentUpdate = function () {
    return false;
  };

  SkeletonWords.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        baseColor = _a.baseColor,
        highlightColor = _a.highlightColor,
        height = _a.height,
        padding = _a.padding,
        margin = _a.margin,
        duration = _a.duration,
        radius = _a.radius,
        customStyle = _a.customStyle;
    var injectedProps = {
      baseColor: baseColor,
      highlightColor: highlightColor,
      duration: duration,
      customStyle: customStyle
    };
    var cssProps = {
      height: height,
      padding: padding,
      margin: margin,
      radius: radius
    };
    return createElement(SkeletonThemeConsumer, null, function (theme) {
      return createElement(Container$1, null, _this.data.map(function (text, index) {
        return createElement(Span, _assign({
          key: index,
          theme: theme,
          cssProps: cssProps
        }, injectedProps), text);
      }));
    });
  };

  SkeletonWords.defaultProps = {
    num: 3,
    baseColor: defaultBaseColor,
    highlightColor: defaultHighlightColor,
    height: '15px',
    padding: '0 20px',
    margin: '0 15px 12px 0',
    radius: '0',
    duration: defaultDuration
  };
  return SkeletonWords;
}(Component);

var templateObject_1$3;
export { Skeleton, SkeletonString, SkeletonWords, SkeletonThemeProvider };